<template>
  <table class="table" :id="dataTable.id">
    <thead>
      <tr>
        <th>Nome</th>
        <th>CNPJ</th>
        <th class="text-center">Status</th>
        <th class="text-center">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="bidderPartner in biddersPartners" :key="bidderPartner.id">
        <td>{{ bidderPartner.name }}</td>
        <td>{{ bidderPartner.cnpj }}</td>
        <td
          class="text-center"
          v-html="statusTranslate(bidderPartner.status)"
        />
        <td class="text-center">
          <router-link
            :to="`${linkDetails}/${bidderPartner.id}`"
            class="btn btn-outline-primary btn-icon rounded-pill"
            title="Detalhes"
          >
            <i class="ph-file-text" />
          </router-link>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { statusTranslate } from '@/utils/strings'
import TypeBidderPartnerEnum from '@/enum/typeBidderPartnerEnum'

export default {
  name: 'ListBiddersPartners',

  props: {
    biddersPartners: {
      type: Array,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      dataTable: {
        id: 'dataTableListBiddersPartners',
        columnDefs: [
          {
            targets: [3],
            orderable: false,
            width: 100,
          },
        ],
      },
      statusTranslate,
    }
  },

  computed: {
    linkDetails() {
      return this.type === TypeBidderPartnerEnum.BIDDER ? 'bidders' : 'partners'
    },
  },

  methods: {
    createDataTable() {
      window.$(`#${this.dataTable.id}`).DataTable({
        order: this.dataTable.order,
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
